(function () {
  "use strict";

  if (window.__dilaChatWidgetLoaded) return;
  window.__dilaChatWidgetLoaded = true;

  var script = document.currentScript;
  if (!script) return;

  var chatEndpoint = script.dataset.chatEndpoint || "http://localhost:5678/webhook/dila-chat-widget/chat";
  var feedbackEndpoint = script.dataset.feedbackEndpoint || chatEndpoint.replace(/\/chat\/?$/, "/feedback");
  var orderEndpoint = script.dataset.orderEndpoint || chatEndpoint.replace(/\/chat\/?$/, "/order-status");
  var pollEndpoint = script.dataset.pollEndpoint || chatEndpoint.replace(/\/chat\/?$/, "/poll");
  var widgetTitle = script.dataset.widgetTitle || "Grupo Dila";
  var styleHref = new URL("dila-chat-widget.css", script.src).href;
  // Varias conversaciones por visitante: un índice con las conversaciones y el
  // historial de cada una guardado aparte. Todo en `localStorage` para que
  // sobreviva al cierre del navegador (antes el historial moría con la pestaña).
  var indexKey = "dila_chat_conversations_v1";
  var historyPrefix = "dila_chat_history_v1:";
  var sessionId = null;                 // conversación abierta ahora mismo
  var state = {
    open: false, sending: false, tracking: false, messages: [],
    view: "home", conversations: readIndex(),
    // Atención humana: cuando alguien del equipo toma la conversación, el bot
    // deja de responder y sus mensajes llegan por sondeo (no hay push).
    humanMode: false, lastAgentId: 0, pollTimer: null
  };

  if (!document.querySelector('link[data-dila-chat-style]')) {
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = styleHref;
    link.dataset.dilaChatStyle = "true";
    document.head.appendChild(link);
  }

  var root = document.createElement("div");
  root.className = "dila-chat-widget";
  // Tres vistas: inicio (menú), lista de conversaciones y la conversación
  // abierta. Así el chat deja de ser un hilo infinito y el cliente puede
  // recuperar consultas anteriores, como en Intercom.
  root.innerHTML = [
    '<section class="dila-chat-panel" hidden aria-label="Chat de atención al cliente">',

    '  <div class="dila-view dila-view--home">',
    '    <header class="dila-home-header">',
    '      <div class="dila-home-top">',
    '        <span class="dila-home-mark" aria-hidden="true">GD</span>',
    '        <button class="dila-chat-close" type="button" aria-label="Cerrar chat">×</button>',
    '      </div>',
    '      <h2 class="dila-home-title">Hola <span aria-hidden="true">👋</span><br>¿Cómo podemos ayudarte?</h2>',
    '    </header>',
    '    <div class="dila-home-body">',
    '      <button class="dila-action-card" type="button" data-nueva>',
    '        <span class="dila-action-text"><strong>Envíanos un mensaje</strong><small>Te respondemos por aquí mismo</small></span>',
    '        <span class="dila-action-icon" aria-hidden="true">➤</span>',
    '      </button>',
    '      <div class="dila-home-recent"></div>',
    '    </div>',
    '  </div>',

    '  <div class="dila-view dila-view--list" hidden>',
    '    <header class="dila-list-header">',
    '      <strong>Mensajes</strong>',
    '      <button class="dila-chat-close" type="button" aria-label="Cerrar chat">×</button>',
    '    </header>',
    '    <div class="dila-conv-list"></div>',
    '    <div class="dila-list-footer">',
    '      <button class="dila-btn-primary" type="button" data-nueva>Envíanos un mensaje <span aria-hidden="true">➤</span></button>',
    '    </div>',
    '  </div>',

    '  <div class="dila-view dila-view--chat" hidden>',
    '    <header class="dila-chat-header">',
    '      <button class="dila-chat-back" type="button" aria-label="Volver a mis mensajes">‹</button>',
    '      <div class="dila-chat-avatar" aria-hidden="true">GD</div>',
    '      <div class="dila-chat-heading"><strong></strong><span class="dila-chat-status">Asistente virtual</span></div>',
    '      <button class="dila-chat-close" type="button" aria-label="Cerrar chat">×</button>',
    '    </header>',
    '    <div class="dila-chat-messages" role="log" aria-live="polite" aria-relevant="additions"></div>',
    '    <div class="dila-chat-composer">',
    '      <form class="dila-chat-form">',
    '        <textarea class="dila-chat-input" rows="1" maxlength="1000" placeholder="Escribe tu consulta…" aria-label="Mensaje"></textarea>',
    '        <button class="dila-chat-send" type="submit" aria-label="Enviar mensaje">↑</button>',
    '      </form>',
    '      <div class="dila-chat-meta"><span>Intro para enviar · Mayús + Intro para salto</span><span class="dila-chat-counter">0/1000</span></div>',
    '    </div>',
    '    <div class="dila-chat-privacy">Al escribir aceptas que Grupo Dila trate tus datos para atender tu consulta. Las conversaciones se anonimizan al año. Puedes ejercer tus derechos en <a href="mailto:info@grupodila.com">info@grupodila.com</a>. <a href="https://grupodila.com/policies/privacy-policy" target="_blank" rel="noopener">Política de privacidad</a>.</div>',
    '  </div>',

    // Iconos en SVG en vez de emoji: los emoji cambian de forma y de color
    // según el sistema operativo (y en Windows salían morados y borrosos).
    '  <nav class="dila-tabs" aria-label="Secciones del chat">',
    '    <button type="button" class="dila-tab is-active" data-tab="home">',
    '      <svg class="dila-tab-icon" viewBox="0 0 24 24" aria-hidden="true">',
    '        <path d="M3.2 10.1 12 3.4l8.8 6.7" /><path d="M5.6 11.3V19a1.4 1.4 0 0 0 1.4 1.4h3.2v-4.6h3.6v4.6H17a1.4 1.4 0 0 0 1.4-1.4v-7.7" />',
    '      </svg>Inicio</button>',
    '    <button type="button" class="dila-tab" data-tab="list">',
    '      <svg class="dila-tab-icon" viewBox="0 0 24 24" aria-hidden="true">',
    '        <path d="M20.5 11.6c0 4.2-3.8 7.6-8.5 7.6a9.6 9.6 0 0 1-2.9-.45L4.2 20.3l1.35-3.6A7.3 7.3 0 0 1 3.5 11.6C3.5 7.4 7.3 4 12 4s8.5 3.4 8.5 7.6Z" />',
    '      </svg>Mensajes<span class="dila-tab-badge" hidden></span></button>',
    '  </nav>',
    '</section>',
    '<button class="dila-chat-launcher" type="button" aria-label="Abrir chat" aria-expanded="false">',
    '  <span class="dila-chat-launcher-mark" aria-hidden="true">GD</span>',
    '  <span class="dila-chat-launcher-label">¿Te ayudamos?</span>',
    '  <span class="dila-launcher-badge" hidden></span>',
    '</button>'
  ].join("");
  document.body.appendChild(root);

  var panel = root.querySelector(".dila-chat-panel");
  var launcher = root.querySelector(".dila-chat-launcher");
  var heading = root.querySelector(".dila-chat-heading strong");
  var messageList = root.querySelector(".dila-chat-messages");
  var form = root.querySelector(".dila-chat-form");
  var input = root.querySelector(".dila-chat-input");
  var sendButton = root.querySelector(".dila-chat-send");
  var counter = root.querySelector(".dila-chat-counter");
  var vistas = {
    home: root.querySelector(".dila-view--home"),
    list: root.querySelector(".dila-view--list"),
    chat: root.querySelector(".dila-view--chat")
  };
  var tabs = root.querySelectorAll(".dila-tab");
  var tabBadge = root.querySelector(".dila-tab-badge");
  var launcherBadge = root.querySelector(".dila-launcher-badge");
  heading.textContent = widgetTitle;
  sendButton.disabled = true;

  var stickyCart = document.querySelector("hdt-sticky-btn-atc");
  var backToTop = document.querySelector(".hdt-back-to-top");
  var stickyCartFrame = null;
  var stickyCartTrackingUntil = 0;

  function updateStickyCartOffset() {
    if (!stickyCart) return;
    var rect = stickyCart.getBoundingClientRect();
    var visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    var stickyCartVisible = visibleHeight > 1;
    root.classList.toggle("dila-chat-widget--sticky-cart-visible", stickyCartVisible);
    root.style.setProperty("--dila-sticky-cart-height", Math.ceil(visibleHeight) + "px");

    if (backToTop) {
      if (stickyCartVisible) {
        var rootRect = root.getBoundingClientRect();
        var rootBottomGap = Math.max(0, window.innerHeight - rootRect.bottom);
        var launcherHeight = launcher.getBoundingClientRect().height || 60;
        var backToTopBottom = visibleHeight + rootBottomGap + launcherHeight + 10;
        backToTop.style.setProperty("bottom", Math.ceil(backToTopBottom) + "px", "important");
      } else {
        backToTop.style.removeProperty("bottom");
      }
    }
  }

  function queueStickyCartOffset() {
    if (stickyCartFrame) return;
    stickyCartFrame = window.requestAnimationFrame(function () {
      stickyCartFrame = null;
      updateStickyCartOffset();
    });
  }

  function trackStickyCartTransition() {
    stickyCartTrackingUntil = performance.now() + 500;
    function track(now) {
      updateStickyCartOffset();
      if (now < stickyCartTrackingUntil) window.requestAnimationFrame(track);
    }
    window.requestAnimationFrame(track);
  }

  if (stickyCart) {
    window.addEventListener("scroll", queueStickyCartOffset, { passive: true });
    window.addEventListener("resize", queueStickyCartOffset);
    stickyCart.addEventListener("transitionrun", trackStickyCartTransition);
    stickyCart.addEventListener("transitionend", queueStickyCartOffset);
    updateStickyCartOffset();
  }

  root.querySelectorAll(".dila-chat-close").forEach(function (b) {
    b.addEventListener("click", function () { setOpen(false); });
  });
  root.querySelectorAll("[data-nueva]").forEach(function (b) {
    b.addEventListener("click", function () { abrirConversacion(null); });
  });
  root.querySelector(".dila-chat-back").addEventListener("click", function () { mostrarVista("list"); });
  tabs.forEach(function (t) {
    t.addEventListener("click", function () { mostrarVista(t.dataset.tab); });
  });

  launcher.addEventListener("click", function () { setOpen(!state.open); });
  form.addEventListener("submit", function (event) {
    event.preventDefault();
    sendMessage(input.value);
  });
  input.addEventListener("keydown", function (event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });
  input.addEventListener("input", function () {
    autoSizeInput();
    counter.textContent = input.value.length + "/1000";
    counter.classList.toggle("is-visible", input.value.length >= 800);
    sendButton.disabled = state.sending || !input.value.trim();
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && state.open) {
      // Dentro de una conversación, Escape vuelve a la lista antes de cerrar
      if (state.view === "chat") mostrarVista("list");
      else setOpen(false);
    }
  });

  pintarBadges();
  mostrarVista("home");

  // ---- Índice de conversaciones y almacenamiento ------------------------
  function readIndex() {
    try {
      var raw = JSON.parse(localStorage.getItem(indexKey) || "[]");
      return Array.isArray(raw) ? raw : [];
    } catch (_) { return []; }
  }

  function writeIndex() {
    try {
      // Se conservan las 20 últimas para no llenar el almacenamiento del navegador
      state.conversations = state.conversations
        .sort(function (a, b) { return (b.updatedAt || 0) - (a.updatedAt || 0); })
        .slice(0, 20);
      localStorage.setItem(indexKey, JSON.stringify(state.conversations));
    } catch (_) { /* almacenamiento opcional */ }
  }

  function conversacion(id) {
    for (var i = 0; i < state.conversations.length; i += 1) {
      if (state.conversations[i].id === id) return state.conversations[i];
    }
    return null;
  }

  function actualizarConversacion(id, cambios) {
    var c = conversacion(id);
    if (!c) {
      c = { id: id, titulo: "", ultimo: "", updatedAt: Date.now(), sinLeer: 0, lastAgentId: 0 };
      state.conversations.push(c);
    }
    Object.keys(cambios || {}).forEach(function (k) { c[k] = cambios[k]; });
    c.updatedAt = cambios && cambios.updatedAt ? cambios.updatedAt : Date.now();
    writeIndex();
    pintarBadges();
    return c;
  }

  function totalSinLeer() {
    return state.conversations.reduce(function (n, c) { return n + (c.sinLeer || 0); }, 0);
  }

  function pintarBadges() {
    var n = totalSinLeer();
    [tabBadge, launcherBadge].forEach(function (el) {
      if (!el) return;
      el.textContent = n > 9 ? "9+" : String(n);
      el.hidden = n === 0;
    });
  }

  function createSessionId() {
    var randomPart = window.crypto && crypto.randomUUID
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    return "dila-widget-" + randomPart;
  }

  // Si la memoria de la sesión quedó incompatible en n8n, se sigue en una
  // conversación nueva conservando lo ya escrito en pantalla.
  function renewSessionId() {
    var anterior = sessionId;
    sessionId = createSessionId();
    actualizarConversacion(sessionId, {
      titulo: (conversacion(anterior) || {}).titulo || "Nueva consulta",
      ultimo: (conversacion(anterior) || {}).ultimo || "",
      lastAgentId: 0
    });
    writeHistory();
  }

  // ---- Vistas ----------------------------------------------------------
  function mostrarVista(nombre) {
    state.view = nombre;
    Object.keys(vistas).forEach(function (k) { vistas[k].hidden = k !== nombre; });
    tabs.forEach(function (t) { t.classList.toggle("is-active", t.dataset.tab === nombre); });
    // La barra de pestañas estorba dentro de una conversación
    root.querySelector(".dila-tabs").hidden = nombre === "chat";
    // Fuera de una conversación no hace falta sondear mensajes del equipo:
    // al volver a inicio/lista se refrescan los avisos de «sin leer».
    if (nombre !== "chat") { stopPolling(); refrescarSinLeer(); }
    if (nombre === "home") pintarInicio();
    if (nombre === "list") pintarLista();
    if (nombre === "chat") {
      renderMessages();
      window.setTimeout(function () { input.focus(); scrollToEnd(); }, 40);
    }
  }

  function resumenConversacion(c) {
    var cuando = fechaCorta(c.updatedAt);
    return [
      '<button type="button" class="dila-conv" data-conv="' + escapeAttr(c.id) + '">',
      '  <span class="dila-conv-avatar" aria-hidden="true">GD</span>',
      '  <span class="dila-conv-body">',
      '    <span class="dila-conv-title">' + escapeHtml(c.titulo || "Conversación") + '</span>',
      '    <span class="dila-conv-last">' + escapeHtml(c.ultimo || "") + '</span>',
      '  </span>',
      '  <span class="dila-conv-meta">' + escapeHtml(cuando) +
        (c.sinLeer ? '<span class="dila-conv-dot" aria-label="Mensajes sin leer"></span>' : '') + '</span>',
      '</button>'
    ].join("");
  }

  function pintarInicio() {
    var caja = root.querySelector(".dila-home-recent");
    var recientes = state.conversations.slice(0, 3);
    caja.innerHTML = recientes.length
      ? '<div class="dila-home-recent-title">Tus conversaciones</div>' + recientes.map(resumenConversacion).join("") +
        (state.conversations.length > 3 ? '<button type="button" class="dila-link-todas" data-tab-link="list">Ver todas</button>' : '')
      : "";
    enlazarConversaciones(caja);
  }

  function pintarLista() {
    var caja = root.querySelector(".dila-conv-list");
    caja.innerHTML = state.conversations.length
      ? state.conversations.map(resumenConversacion).join("")
      : '<div class="dila-conv-vacio">Todavía no has escrito ninguna consulta.<br>Pulsa «Envíanos un mensaje» para empezar.</div>';
    enlazarConversaciones(caja);
  }

  function enlazarConversaciones(caja) {
    caja.querySelectorAll("[data-conv]").forEach(function (b) {
      b.addEventListener("click", function () { abrirConversacion(b.dataset.conv); });
    });
    var todas = caja.querySelector("[data-tab-link]");
    if (todas) todas.addEventListener("click", function () { mostrarVista("list"); });
  }

  // Abre una conversación existente o crea una nueva (id = null)
  function abrirConversacion(id) {
    stopPolling();
    if (!id) {
      id = createSessionId();
      sessionId = id;
      state.messages = [{
        id: makeId("welcome"),
        role: "assistant",
        content: "¡Hola! Soy el asistente virtual de Grupo Dila. Puedo ayudarte a encontrar productos, consultar servicios o resolver dudas sobre la tienda.",
        welcome: true,
        createdAt: Date.now()
      }];
      state.lastAgentId = 0;
      writeHistory();
      actualizarConversacion(id, { titulo: "Nueva consulta", ultimo: "", sinLeer: 0, lastAgentId: 0 });
    } else {
      sessionId = id;
      state.messages = readHistory();
      var c = conversacion(id);
      state.lastAgentId = (c && c.lastAgentId) || 0;
      if (c && c.sinLeer) actualizarConversacion(id, { sinLeer: 0 });
    }
    state.humanMode = false;
    mostrarVista("chat");
    startPolling(true);
  }

  function fechaCorta(ts) {
    if (!ts) return "";
    var diff = Date.now() - ts;
    var min = Math.round(diff / 60000);
    if (min < 1) return "ahora";
    if (min < 60) return min + " min";
    var h = Math.round(min / 60);
    if (h < 24) return h + " h";
    var d = Math.round(h / 24);
    if (d < 7) return d + " d";
    return Math.round(d / 7) + " sem";
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  // El historial se guarda por conversación y en `localStorage`, para que el
  // cliente pueda cerrar el navegador y recuperar consultas anteriores.
  function readHistory(id) {
    try {
      var parsed = JSON.parse(localStorage.getItem(historyPrefix + (id || sessionId)) || "[]");
      return Array.isArray(parsed)
        ? parsed.filter(function (message) { return !message.error; }).slice(-60)
        : [];
    } catch (_) {
      return [];
    }
  }

  function writeHistory(id, mensajes) {
    try {
      localStorage.setItem(historyPrefix + (id || sessionId),
        JSON.stringify((mensajes || state.messages).slice(-60)));
    } catch (_) { /* almacenamiento opcional */ }
  }

  function makeId(prefix) {
    return prefix + "-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
  }

  function setOpen(open) {
    state.open = open;
    panel.hidden = !open;
    launcher.setAttribute("aria-expanded", String(open));
    launcher.setAttribute("aria-label", open ? "Cerrar chat" : "Abrir chat");
    if (open) {
      // Se abre siempre en el menú de inicio, no en el último hilo.
      mostrarVista(state.view === "chat" ? "chat" : "home");
      // Comprueba si el equipo respondió mientras el chat estaba cerrado.
      if (state.view === "chat") startPolling(true);
      else refrescarSinLeer();
    } else {
      stopPolling();
      launcher.focus();
    }
  }

  // Revisa las conversaciones recientes por si el equipo ha contestado
  // mientras el cliente no estaba mirando. Se limita a 5 para no disparar
  // peticiones en una tienda con muchas visitas.
  async function refrescarSinLeer() {
    var recientes = state.conversations.slice(0, 5);
    for (var i = 0; i < recientes.length; i += 1) {
      var c = recientes[i];
      if (c.id === sessionId && state.view === "chat") continue;
      try {
        var respuesta = await fetch(pollEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sessionId: c.id, afterId: c.lastAgentId || 0 })
        });
        if (!respuesta.ok) continue;
        var datos = await respuesta.json().catch(function () { return {}; });
        var nuevos = Array.isArray(datos.mensajes) ? datos.mensajes : [];
        if (!nuevos.length) continue;

        var historial = readHistory(c.id);
        var ultimoId = c.lastAgentId || 0;
        nuevos.forEach(function (m) {
          ultimoId = Math.max(ultimoId, Number(m.id) || 0);
          historial.push({
            id: makeId("agent"), role: "agent", content: String(m.texto || ""),
            agentMessageId: String(m.id), agentName: m.agente || "", createdAt: Date.now()
          });
        });
        writeHistory(c.id, historial);
        actualizarConversacion(c.id, {
          lastAgentId: ultimoId,
          sinLeer: (c.sinLeer || 0) + nuevos.length,
          ultimo: nuevos[nuevos.length - 1].texto
        });
      } catch (_) { /* se reintenta la próxima vez que abra el chat */ }
    }
    if (state.view === "home") pintarInicio();
    if (state.view === "list") pintarLista();
  }

  function autoSizeInput() {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 110) + "px";
  }

  async function sendMessage(rawText) {
    var text = String(rawText || "").trim();
    if (!text || state.sending) return;

    state.sending = true;
    input.value = "";
    autoSizeInput();
    counter.textContent = "0/1000";
    counter.classList.remove("is-visible");
    sendButton.disabled = true;

    addMessage({ id: makeId("user"), role: "user", content: text, createdAt: Date.now() });
    renderTyping();

    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 90000);

    try {
      var response = await fetch(chatEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "sendMessage", sessionId: sessionId, chatInput: text }),
        signal: controller.signal
      });
      var payload = await response.json().catch(function () { return {}; });

      // La memoria puede quedar incompatible si cambia el modelo o la credencial
      // mientras había una llamada a herramienta en curso. Ante un error interno,
      // se reintenta una sola vez con una sesión limpia.
      if (response.status >= 500) {
        renewSessionId();
        response = await fetch(chatEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "sendMessage", sessionId: sessionId, chatInput: text }),
          signal: controller.signal
        });
        payload = await response.json().catch(function () { return {}; });
      }

      if (!response.ok) throw new Error("Respuesta de chat no válida");

      // `output` vacío significa que la conversación la está atendiendo una
      // persona del equipo: el bot calla a propósito y la respuesta llegará
      // por el sondeo. No se pinta ninguna burbuja del bot.
      if (payload.output == null || payload.output === "") {
        removeTyping();
        state.humanMode = true;
        showHumanNotice();
        startPolling(true);
        return;
      }
      if (typeof payload.output !== "string") throw new Error("Respuesta de chat no válida");

      removeTyping();
      addMessage({
        id: makeId("assistant"),
        role: "assistant",
        content: payload.output,
        messageId: payload.messageId == null ? null : String(payload.messageId),
        createdAt: Date.now()
      });
    } catch (error) {
      removeTyping();
      addMessage({
        id: makeId("error"),
        role: "assistant",
        content: error && error.name === "AbortError"
          ? "La respuesta está tardando más de lo esperado. Inténtalo de nuevo en un momento."
          : "No he podido conectar con el asistente. Comprueba que n8n está en marcha e inténtalo de nuevo.",
        error: true,
        createdAt: Date.now()
      });
    } finally {
      window.clearTimeout(timeout);
      state.sending = false;
      sendButton.disabled = !input.value.trim();
      input.focus();
    }
  }

  function addMessage(message) {
    state.messages.push(message);
    writeHistory();
    renderMessages();

    // El índice guarda de qué iba la conversación y lo último dicho, que es lo
    // que se ve en la lista de «Mensajes».
    if (message.welcome || message.role === "order-form") return;
    var cambios = { ultimo: String(message.content || "").slice(0, 90) };
    var c = conversacion(sessionId);
    if (message.role === "user" && (!c || !c.titulo || c.titulo === "Nueva consulta")) {
      cambios.titulo = String(message.content || "").slice(0, 60);
    }
    actualizarConversacion(sessionId, cambios);
  }

  // ---- Atención por una persona del equipo -------------------------------
  // No hay canal push: el widget pregunta cada pocos segundos si alguien del
  // equipo ha escrito. Solo mientras el chat está abierto, para no gastar
  // peticiones con el panel cerrado.
  function showHumanNotice() {
    if (state.messages.some(function (m) { return m.humanNotice; })) return;
    addMessage({
      id: makeId("notice"),
      role: "assistant",
      content: "Un compañero del equipo está viendo tu consulta y te responde por aquí en un momento.",
      system: true,
      humanNotice: true,
      createdAt: Date.now()
    });
  }

  async function pollAgentMessages() {
    try {
      var response = await fetch(pollEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionId: sessionId, afterId: state.lastAgentId || 0 })
      });
      if (!response.ok) return;
      var payload = await response.json().catch(function () { return {}; });

      state.humanMode = Boolean(payload.modo_humano);
      var nuevos = Array.isArray(payload.mensajes) ? payload.mensajes : [];
      nuevos.forEach(function (m) {
        state.lastAgentId = Math.max(state.lastAgentId || 0, Number(m.id) || 0);
        addMessage({
          id: makeId("agent"),
          role: "agent",
          content: String(m.texto || ""),
          agentMessageId: String(m.id),
          agentName: m.agente || "",
          createdAt: Date.now()
        });
      });
      if (nuevos.length) actualizarConversacion(sessionId, { lastAgentId: state.lastAgentId, sinLeer: 0 });
      // OJO: aquí NO se puede parar el sondeo por «no hay modo humano». El
      // sondeo arranca al abrir cualquier conversación, y una respuesta del
      // equipo puede llegar minutos después; si se apagara en la primera
      // comprobación, esa respuesta no llegaría nunca al cliente. Se detiene
      // al salir de la conversación o al cerrar el chat (mostrarVista/setOpen).
    } catch (_) { /* la próxima vuelta lo reintenta */ }
  }

  function startPolling(immediate) {
    if (state.pollTimer) return;
    if (immediate) pollAgentMessages();
    state.pollTimer = window.setInterval(function () {
      if (state.open) pollAgentMessages();
    }, 8000);
  }

  function stopPolling() {
    if (!state.pollTimer) return;
    window.clearInterval(state.pollTimer);
    state.pollTimer = null;
  }

  function renderMessages() {
    messageList.textContent = "";
    state.messages.forEach(function (message, index) {
      messageList.appendChild(createMessageElement(message));
      if (message.welcome && index === 0 && state.messages.length === 1) {
        messageList.appendChild(createQuickReplies());
      }
    });
    scrollToEnd();
  }

  function createMessageElement(message) {
    if (message.role === "order-form") return createOrderTrackingForm(message);

    var article = document.createElement("article");
    article.className = "dila-chat-message dila-chat-message--" + message.role;
    article.dataset.messageKey = message.id;

    var inner = document.createElement("div");
    inner.className = "dila-chat-message-inner";
    var bubble = document.createElement("div");
    bubble.className = "dila-chat-bubble";

    if (message.role === "assistant") bubble.appendChild(renderBotContent(message.content));
    else bubble.textContent = message.content;

    // Los mensajes escritos por una persona del equipo se identifican como
    // tales: el cliente debe saber que ya no le habla el asistente.
    if (message.role === "agent") {
      var who = document.createElement("span");
      who.className = "dila-chat-agent-name";
      who.textContent = message.agentName
        ? "Equipo Grupo Dila · " + message.agentName
        : "Equipo Grupo Dila";
      inner.appendChild(who);
    }

    inner.appendChild(bubble);
    if (message.role === "assistant" && !message.welcome && !message.error && !message.system) inner.appendChild(createFeedback(message));
    article.appendChild(inner);
    return article;
  }

  function createQuickReplies() {
    var prompts = [
      ["Hacer seguimiento de mi pedido", "order"],
      ["¿Dónde está la tienda?", "location"]
    ];
    var wrap = document.createElement("div");
    wrap.className = "dila-chat-quick-replies";
    wrap.setAttribute("aria-label", "Consultas frecuentes");
    prompts.forEach(function (item) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "dila-quick-reply";
      button.textContent = item[0];
      button.addEventListener("click", function () {
        if (item[1] === "order") startOrderTracking();
        else sendMessage("¿Dónde estáis y qué horario tenéis?");
      });
      wrap.appendChild(button);
    });
    return wrap;
  }

  function startOrderTracking() {
    if (state.sending || state.tracking || state.messages.some(function (message) { return message.role === "order-form"; })) return;
    addMessage({ id: makeId("user"), role: "user", content: "Hacer seguimiento de mi pedido", createdAt: Date.now() });
    addMessage({
      id: makeId("assistant"),
      role: "assistant",
      content: "Para consultar el estado, indícanos el número del pedido y el correo electrónico utilizado en la compra.",
      system: true,
      createdAt: Date.now()
    });
    addMessage({ id: makeId("order-form"), role: "order-form", createdAt: Date.now() });
  }

  function createOrderTrackingForm(message) {
    var article = document.createElement("article");
    article.className = "dila-chat-order-card";
    article.dataset.messageKey = message.id;

    var title = document.createElement("strong");
    title.className = "dila-chat-order-title";
    title.textContent = "Seguimiento de pedido";

    var subtitle = document.createElement("span");
    subtitle.className = "dila-chat-order-subtitle";
    subtitle.textContent = "Proporciona tu información.";

    var formElement = document.createElement("form");
    formElement.className = "dila-chat-order-form";

    var orderInput = document.createElement("input");
    orderInput.type = "text";
    orderInput.name = "orderNumber";
    orderInput.maxLength = 40;
    orderInput.placeholder = "Número de pedido";
    orderInput.setAttribute("aria-label", "Número de pedido");
    orderInput.autocomplete = "off";
    orderInput.required = true;

    var emailInput = document.createElement("input");
    emailInput.type = "email";
    emailInput.name = "email";
    emailInput.maxLength = 254;
    emailInput.placeholder = "Dirección de correo electrónico";
    emailInput.setAttribute("aria-label", "Dirección de correo electrónico");
    emailInput.autocomplete = "email";
    emailInput.required = true;

    var error = document.createElement("div");
    error.className = "dila-chat-order-error";
    error.setAttribute("role", "alert");

    var actions = document.createElement("div");
    actions.className = "dila-chat-order-actions";
    var cancel = document.createElement("button");
    cancel.type = "button";
    cancel.className = "dila-chat-order-cancel";
    cancel.textContent = "Cancelar";
    var submit = document.createElement("button");
    submit.type = "submit";
    submit.className = "dila-chat-order-submit";
    submit.textContent = "Consultar pedido";

    cancel.addEventListener("click", function () {
      removeMessage(message.id);
      input.focus();
    });
    formElement.addEventListener("submit", function (event) {
      event.preventDefault();
      var orderNumber = orderInput.value.trim();
      var email = emailInput.value.trim();
      if (!orderNumber || !emailInput.checkValidity()) {
        error.textContent = "Revisa el número de pedido y el correo electrónico.";
        return;
      }
      submitOrderTracking(message.id, orderNumber, email);
    });

    actions.append(cancel, submit);
    formElement.append(orderInput, emailInput, error, actions);
    article.append(title, subtitle, formElement);
    return article;
  }

  function removeMessage(messageId) {
    state.messages = state.messages.filter(function (message) { return message.id !== messageId; });
    writeHistory();
    renderMessages();
  }

  async function submitOrderTracking(formMessageId, orderNumber, email) {
    if (state.tracking) return;
    state.tracking = true;
    removeMessage(formMessageId);
    addMessage({ id: makeId("user"), role: "user", content: "Consultar el pedido " + orderNumber, createdAt: Date.now() });
    renderTyping();

    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 30000);
    try {
      var response = await fetch(orderEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionId: sessionId, orderNumber: orderNumber, email: email }),
        signal: controller.signal
      });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok || typeof payload.message !== "string") throw new Error("Respuesta de seguimiento no válida");
      removeTyping();
      addMessage({ id: makeId("assistant"), role: "assistant", content: payload.message, system: true, createdAt: Date.now() });
    } catch (requestError) {
      removeTyping();
      addMessage({
        id: makeId("error"),
        role: "assistant",
        content: requestError && requestError.name === "AbortError"
          ? "La consulta está tardando más de lo esperado. Inténtalo de nuevo en un momento."
          : "No he podido consultar el pedido ahora mismo. Inténtalo de nuevo o habla con nuestro equipo.",
        error: true,
        system: true,
        createdAt: Date.now()
      });
    } finally {
      window.clearTimeout(timeout);
      state.tracking = false;
      input.focus();
    }
  }

  function renderTyping() {
    removeTyping();
    var article = document.createElement("article");
    article.className = "dila-chat-message dila-chat-message--assistant";
    article.dataset.typing = "true";
    article.innerHTML = '<div class="dila-chat-message-inner"><div class="dila-chat-bubble"><div class="dila-chat-typing" aria-label="El asistente está escribiendo"><span></span><span></span><span></span></div></div></div>';
    messageList.appendChild(article);
    scrollToEnd();
  }

  function removeTyping() {
    var typing = messageList.querySelector('[data-typing="true"]');
    if (typing) typing.remove();
  }

  function scrollToEnd() {
    window.requestAnimationFrame(function () { messageList.scrollTop = messageList.scrollHeight; });
  }

  function renderBotContent(markdown) {
    var fragment = document.createDocumentFragment();
    var lines = String(markdown || "").replace(/\r\n/g, "\n").split("\n");
    var textBuffer = [];

    function flushText() {
      if (!textBuffer.length) return;
      fragment.appendChild(renderMarkdownBlocks(textBuffer.join("\n")));
      textBuffer = [];
    }

    // Un bloque de producto es «N. Nombre» seguido, en las líneas siguientes y
    // en cualquier orden, de una imagen, un enlace y (opcionalmente) un precio.
    // Se admiten líneas en blanco intercaladas: exigir un orden exacto hacía
    // que cualquier variación del modelo tirara la tarjeta abajo y el chat
    // acabara mostrando el Markdown en bruto.
    var RE_TITULO = /^\s*(\d+)[.)]\s+(.+?)\s*$/;
    var RE_IMAGEN = /^\s*!\[([^\]]*)\]\((https?:\/\/[^)\s]+)\)\s*$/i;
    var RE_ENLACE = /^\s*\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)\s*$/i;
    var RE_PRECIO = /^\s*\*{0,2}\s*((?:precio:\s*)?[\d.,]+\s*€[^*]*?)\s*\*{0,2}\s*$/i;

    for (var i = 0; i < lines.length; i += 1) {
      var titleMatch = lines[i].match(RE_TITULO);
      if (titleMatch) {
        var imagen = null, enlace = null, precio = null, ultima = i;
        for (var j = i + 1; j < lines.length && j <= i + 7; j += 1) {
          if (!lines[j].trim()) continue;              // línea en blanco: se salta
          if (RE_TITULO.test(lines[j])) break;         // empieza el siguiente producto
          var mi = lines[j].match(RE_IMAGEN);
          if (mi && !imagen) { imagen = mi; ultima = j; continue; }
          var me = lines[j].match(RE_ENLACE);
          if (me && !enlace) { enlace = me; ultima = j; continue; }
          var mp = lines[j].match(RE_PRECIO);
          if (mp && !precio) { precio = mp; ultima = j; continue; }
          break;                                       // texto normal: fin del bloque
        }

        // Si no hay línea de enlace suelta, se acepta el enlace que el modelo
        // haya puesto dentro del propio título («1. Cortacésped [STIGA 955](url)»),
        // que es una variante que escribe a menudo.
        var urlProducto = enlace && safeUrl(enlace[2]) ? enlace[2] : null;
        var textoEnlace = enlace ? enlace[1] : "";
        if (!urlProducto) {
          var enTitulo = titleMatch[2].match(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/);
          if (enTitulo && safeUrl(enTitulo[2])) { urlProducto = enTitulo[2]; textoEnlace = ""; }
        }

        if (imagen && urlProducto && safeUrl(imagen[2])) {
          flushText();
          fragment.appendChild(createProductCard(
            titleMatch[1], titleMatch[2], imagen[1], imagen[2],
            textoEnlace, urlProducto, precio ? precio[1].trim() : null
          ));
          i = ultima;
          continue;
        }
      }
      textBuffer.push(lines[i]);
    }
    flushText();
    return fragment;
  }

  function createProductCard(index, title, alt, imageUrl, linkText, productUrl, price) {
    var wrap = document.createElement("div");
    wrap.className = "dila-chat-products";
    var card = document.createElement("article");
    card.className = "dila-product-card";
    var image = document.createElement("img");
    image.src = imageUrl;
    image.alt = alt || title;
    image.loading = "lazy";
    image.width = 92;
    image.height = 92;
    // Red de seguridad: si la imagen no carga (URL mal copiada por el modelo,
    // foto borrada en Shopify...), se oculta en vez de dejar el icono de rota.
    // La tarjeta sigue siendo útil: nombre, precio y enlace.
    image.addEventListener("error", function () {
      image.remove();
      card.classList.add("dila-product-card--sin-imagen");
    });
    var body = document.createElement("div");
    body.className = "dila-product-body";
    var number = document.createElement("span");
    number.className = "dila-product-index";
    number.textContent = "Opción " + index;
    var heading = document.createElement("strong");
    heading.className = "dila-product-title";
    heading.textContent = stripMarkdown(title);
    var link = document.createElement("a");
    link.className = "dila-product-link";
    link.href = productUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    // El pie de la tarjeta siempre dice «Ver producto», aunque el modelo haya
    // usado el nombre del producto como texto del enlace.
    link.textContent = (/produto/i.test(linkText || "") ? "Ver produto" : "Ver producto") + " →";
    if (price) {
      var priceEl = document.createElement("span");
      priceEl.className = "dila-product-price";
      priceEl.textContent = price;
      body.append(number, heading, priceEl, link);
    } else {
      body.append(number, heading, link);
    }
    card.append(image, body);
    wrap.appendChild(card);
    return wrap;
  }

  function renderMarkdownBlocks(markdown) {
    var fragment = document.createDocumentFragment();
    var lines = String(markdown || "").split("\n");
    var paragraph = [];

    function flushParagraph() {
      if (!paragraph.length) return;
      var p = document.createElement("p");
      paragraph.forEach(function (line, index) {
        if (index) p.appendChild(document.createElement("br"));
        appendInlineMarkdown(p, line);
      });
      fragment.appendChild(p);
      paragraph = [];
    }

    for (var i = 0; i < lines.length; i += 1) {
      if (!lines[i].trim()) {
        flushParagraph();
        continue;
      }
      if (/^\s*[-*]\s+/.test(lines[i])) {
        flushParagraph();
        var list = document.createElement("ul");
        while (i < lines.length && /^\s*[-*]\s+/.test(lines[i])) {
          var item = document.createElement("li");
          appendInlineMarkdown(item, lines[i].replace(/^\s*[-*]\s+/, ""));
          list.appendChild(item);
          i += 1;
        }
        i -= 1;
        fragment.appendChild(list);
      } else {
        paragraph.push(lines[i]);
      }
    }
    flushParagraph();
    return fragment;
  }

  function appendInlineMarkdown(parent, text) {
    var source = String(text || "");
    var pattern = /!\[([^\]]*)\]\((https?:\/\/[^)\s]+)\)|\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)|\*\*([^*]+)\*\*|`([^`]+)`/gi;
    var cursor = 0;
    var match;
    while ((match = pattern.exec(source))) {
      if (match.index > cursor) parent.appendChild(document.createTextNode(source.slice(cursor, match.index)));
      if (match[1] != null && safeUrl(match[2])) {
        var image = document.createElement("img");
        image.src = match[2];
        image.alt = match[1];
        image.loading = "lazy";
        image.style.maxWidth = "150px";
        image.style.height = "auto";
        image.style.borderRadius = "10px";
        parent.appendChild(image);
      } else if (match[3] != null && safeUrl(match[4])) {
        var link = document.createElement("a");
        link.href = match[4];
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.textContent = match[3];
        parent.appendChild(link);
      } else if (match[5] != null) {
        var strong = document.createElement("strong");
        strong.textContent = match[5];
        parent.appendChild(strong);
      } else if (match[6] != null) {
        var code = document.createElement("code");
        code.textContent = match[6];
        parent.appendChild(code);
      } else {
        parent.appendChild(document.createTextNode(match[0]));
      }
      cursor = pattern.lastIndex;
    }
    if (cursor < source.length) parent.appendChild(document.createTextNode(source.slice(cursor)));
  }

  function safeUrl(value) {
    try {
      var parsed = new URL(value);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (_) {
      return false;
    }
  }

  function stripMarkdown(text) {
    // Quita enlaces en CUALQUIER posición, no solo si ocupan todo el texto: el
    // modelo suele escribir el nombre del producto como enlace dentro del
    // título («Cortacésped gasolina [STIGA COMBI 955 V](...)»).
    return String(text || "")
      .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
      .replace(/\*\*/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function createFeedback(message) {
    var wrap = document.createElement("div");
    wrap.className = "dila-chat-feedback";

    if (message.feedback) {
      var thanks = document.createElement("span");
      thanks.className = "dila-feedback-thanks";
      thanks.textContent = "Gracias por tu valoración";
      wrap.appendChild(thanks);
      return wrap;
    }

    var label = document.createElement("span");
    label.className = "dila-chat-feedback-label";
    label.textContent = "¿Te ayudó?";
    var positive = feedbackButton("👍", "Valorar positivamente");
    var negative = feedbackButton("👎", "Valorar negativamente");
    var enabled = Boolean(message.messageId && feedbackEndpoint);
    positive.disabled = !enabled;
    negative.disabled = !enabled;
    if (!enabled) {
      positive.title = negative.title = "Valoración no disponible para este mensaje";
    }
    positive.addEventListener("click", function () { submitFeedback(message, "positive", "", wrap); });
    negative.addEventListener("click", function () { showNegativeComment(message, wrap); });
    wrap.append(label, positive, negative);
    return wrap;
  }

  function feedbackButton(symbol, label) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "dila-feedback-button";
    button.textContent = symbol;
    button.setAttribute("aria-label", label);
    return button;
  }

  function showNegativeComment(message, wrap) {
    wrap.textContent = "";
    wrap.style.display = "block";
    var box = document.createElement("div");
    box.className = "dila-feedback-comment";
    var textarea = document.createElement("textarea");
    textarea.maxLength = 500;
    textarea.placeholder = "¿Qué podríamos mejorar? (opcional)";
    textarea.setAttribute("aria-label", "Comentario sobre la respuesta");
    var actions = document.createElement("div");
    actions.className = "dila-feedback-actions";
    var send = document.createElement("button");
    send.type = "button";
    send.className = "dila-feedback-send";
    send.textContent = "Enviar";
    var skip = document.createElement("button");
    skip.type = "button";
    skip.className = "dila-feedback-skip";
    skip.textContent = "Sin comentario";
    send.addEventListener("click", function () { submitFeedback(message, "negative", textarea.value.trim(), wrap); });
    skip.addEventListener("click", function () { submitFeedback(message, "negative", "", wrap); });
    actions.append(send, skip);
    box.append(textarea, actions);
    wrap.appendChild(box);
    textarea.focus();
  }

  async function submitFeedback(message, feedback, comment, wrap) {
    Array.prototype.forEach.call(wrap.querySelectorAll("button, textarea"), function (element) { element.disabled = true; });
    try {
      var response = await fetch(feedbackEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionId: sessionId, messageId: message.messageId, feedback: feedback, comentario: comment.slice(0, 500) })
      });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok || payload.ok !== true) throw new Error("No se pudo guardar");
      message.feedback = feedback;
      writeHistory();
      renderMessages();
    } catch (_) {
      wrap.textContent = "No se pudo guardar la valoración. Inténtalo de nuevo.";
    }
  }
})();
